import React, { createContext, useContext, useEffect, useState } from "react";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider as MaterialThemeProvider,
} from "@mui/material/styles";
import { v2theme } from "../styles/Theme";
import default_theme from "../themes/default_theme.json";
// import theme1 from "../themes/theme1.json";
import { CourseStructureContext } from "./CourseStructureContext";
import { CourseStructureCtx } from "../interfaces";

export const ThemeContext = createContext({});

export const ThemeProvider: React.FC = ({ children }) => {
  const courseStructureCtx = useContext(CourseStructureContext) as CourseStructureCtx;
  const [theme, setTheme] = useState(v2theme);

  async function fetchUserThemePreference(courseId: string) {
    // User theme preferences to be implemented here will be done once the requirements is more clear
    // this is done as a placeholder for now
    // if (courseId === "1") {
    //   return default_theme;
    // }
    // if (process.env.REACT_APP_DEPLOYMENT_ENV === "develop") {
    //   // on develop environment, use theme1 for all courses except course 1
    //   return theme1; // for testing purposes only
    // }
    return default_theme;
  }

  useEffect(() => {
    const currentCourse = courseStructureCtx.courseTreeStructure?.getCurrentCourse();
    if (!currentCourse) return;
    let courseId = currentCourse?.id;
    const loadUserTheme = async (courseId: string) => {
      const userTheme = await fetchUserThemePreference(courseId);
      // @ts-ignore
      setTheme(createTheme(userTheme));
    };

    loadUserTheme(courseId);
  }, [courseStructureCtx.courseTreeStructure]);

  return (
    <ThemeContext.Provider value={{ theme }}>
      <StyledEngineProvider injectFirst>
        <MaterialThemeProvider theme={theme}>{children}</MaterialThemeProvider>
      </StyledEngineProvider>
    </ThemeContext.Provider>
  );
};
